
export default {
  props: {
    small: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      color: 'primary'
    }
  }
}
